<template>
    <div class="container">
        <div class="text-wrapper">
            <p class="contact">Love to code</p>
            <p class="title">Platforms Where I Perfect Code</p>
            <p class="description">Passionate problem solver with a love for coding challenges.</p>
        </div>
        <div class="cards-wrapper">
            <div class="platform-card" v-for="platform in platforms" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }">
                <div class="card-header" :class="{ 'secondary': platform.name == 'LeetCode'}">
                    <img :src="platform.logo" alt="">
                    <p class="hint" :class="{ 'secondary': platform.name == 'LeetCode'}">{{ platform.hint }}</p>
                </div>
                <div class="card-body">
                    <div class="content-wrapper">
                        <p class="title-text">{{ platform.title + ' ' + platform.name }}</p>
                        <ul class="description-wrapper">
                            <li class="description" v-if="platform.noOfBadges"> Earned <span class="highlight">{{
                                    platform.noOfBadges }} </span>  badges
                            </li>
                            <li class="description" v-if="platform.certificates.length > 0">
                                Earned certificates in <span class="highlight">{{ platform.certificates.join(', ') }}</span>
                            </li>
                            <li class="description" v-if="platform.badges.length > 0">
                                Earned badges in <span class="highlight">{{ platform.badges.join(', ') }}</span>
                            </li>
                            <li class="description" v-if="platform.problemsSolved > 0">
                                Solved <span class="highlight">{{ platform.problemsSolved }} problems </span> in data structures and algorithms
                            </li>
                        </ul>
                    </div>
                    <a :href="platform.profileLink" class="link" :class="{ 'secondary': platform.name == 'LeetCode'}">Profile Link</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import hackerRankLogo from '@/assets/images/hackerrank-logo.svg';
import leetCodeLogo from '@/assets/images/leetcode-logo.svg';
import geeksForGeeksLogo from '@/assets/images/geeksforgeeks-logo.svg'

export default {
    name: 'LoveToCode',
    data() {
        return {
            platforms: [
                {
                    name: 'HackerRank',
                    logo: hackerRankLogo,
                    profileLink: 'https://www.hackerrank.com/profile/murugeshraja2000',
                    noOfBadges: 5,
                    certificates: ['Problem Solving (Intermediate)', 'Python', 'Angular'],
                    badges: [],
                    hint: '05 Badges',
                    title: 'Murugesh Raja\'s',
                    problemsSolved: 0,
                    rank: 0
                },
                {
                    name: 'LeetCode',
                    logo: leetCodeLogo,
                    profileLink: 'https://leetcode.com/u/MurugeshRajaR/',
                    noOfBadges: 3,
                    hint: '03 Badges',
                    certificates: [],
                    badges: ['50 days challenge', 'Data Structures I', 'Data Structures II'],
                    title: 'Murugesh Raja\'s',
                    problemsSolved: 300,
                    rank: 0
                },
                {
                    name: 'GeeksForGeeks',
                    logo: geeksForGeeksLogo,
                    profileLink: 'https://www.geeksforgeeks.org/user/murugeshraja2000/',
                    noOfBadges: 0,
                    certificates: [],
                    badges: [],
                    title: 'Murugesh Raja\'s',
                    problemsSolved: 92,
                    rank: 247
                }
            ]
        };
    },
    components: {

    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 2rem;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: left;
}

.contact {
    font-size: 1.5rem;
    font-weight: 600;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

.description {
    font-size: 1rem;
    color: var(--secondary-text-color);
}

.cards-wrapper {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: center;
}

.platform-card {
    /* flex: 1; */
    width: 375px;
    display: flex;
    flex-direction: column;
    border: 1px solid #252626;
    border-radius: 20px;
    overflow: hidden;
    min-height: 320px;
    transition: all 0.3s ease-in-out;
}

.platform-card:hover {
    box-shadow: 6px 5px 8px #B66BE1;
    transform: scale(1.05);
}

.card-header {
    display: flex;
    justify-content: space-between;
    padding: 0rem 1.5rem;
    background-color: #0E141E;
    height: 5.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.card-header.secondary {
    background-color: #202020;
}

.hint {
    font-size: 1rem;
    color: #2EC866;
}

.link {
    color: #2EC866;
}

.link.secondary, .hint.secondary {
    color: #EBA340;
}


.card-body {
    background-color: #0C0C0D;
    padding: 1rem 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.description-wrapper {
    padding-left: 1.5rem;
}

@media (max-width: 900px) {

    .title {
        font-size: 2rem;
    }
    .container {
        padding: 3.5rem;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 2rem;
    }
    .title {
        font-size: 1.8rem;
    }

    .text-wrapper {
        text-align: left;
        gap: 10px;
    }

    .contact, .description, .section-title, .section-description, .profile-name {
        font-size: 0.9rem;
    }

    .title {
        font-size: 1.2rem;
    }
}
</style>